import { Component, HostListener } from '@angular/core';
import { ToggleNavService } from './shared/services/toggle-nav.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(public toggleNavSVC: ToggleNavService) {}


  // Variable para controlar la visibilidad
  showFloatingButtons: boolean = false;

  // Escuchamos el scroll de la ventana
  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Si el scroll vertical es mayor a la altura de la ventana (100vh)
    if (window.scrollY > window.innerHeight) {
      this.showFloatingButtons = true;
    } else {
      this.showFloatingButtons = false;
    }
  }
}
